import {useState} from 'react';
// import 'react-modern-calendar-datepicker/lib/DatePicker.css';
// import { Calendar } from 'react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css'
import {Calendar} from '@hassanmojab/react-modern-calendar-datepicker'
import moment from "jalali-moment";
import "./style.scss";

export default function DatePickerModal({show, close, defaultValue, onChange, className}) {

  const [selectedDay, setSelectedDay] = useState(defaultValue);
  const dateConverter = date => {
    setSelectedDay(date);
    const year = date.year;
    const month = ("0" + date.month).substr(-2);
    const day = ("0" + date.day).substr(-2);
    const jalali = year + "-" + month + "-" + day;
    const miladi = moment.from(jalali, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD');

    onChange({fa: jalali, en: miladi, set: true})

    close(false)
  }
  const strToObj = _ => {
    return {
      year: defaultValue?.split("-")[0] * 1 || 1398,
      month: defaultValue?.split("-")[1] * 1 || 1,
      day: defaultValue?.split("-")[2] * 1 || 1,
    }
  }
  return (
    <div className={"date-picker" + (show ? " show" : "") + (className ? " " + className : "")} onClick={_ => close(false)}>
      <div onClick={e => e.stopPropagation()}>
        <Calendar
          onChange={dateConverter}
          value={strToObj()}
          shouldHighlightWeekends
          locale="fa"
        />
      </div>
    </div>
  )
}
